import * as Yup from 'yup';
import { useNavigate } from 'react-router-dom';
import InputMask from 'react-input-mask';

// form
import { Controller, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
// @mui
import { FormControl, InputAdornment, Stack, TextField } from '@mui/material';
import { LoadingButton } from '@mui/lab';
// components
import { FormProvider } from '../../../components/hook-form';

import { api as authApi } from '../../../store/domains/auth';

export default function LoginForm() {
  const navigate = useNavigate();

  const [authMutation] = authApi.usePostAuth();

  const LoginSchema = Yup.object().shape({
    phone: Yup.string().required('Email is required'),
  });

  const defaultValues = {
    phone: '',
  };

  const methods = useForm({
    resolver: yupResolver(LoginSchema),
    defaultValues,
  });

  const {
    handleSubmit,
    formState: { isSubmitting },
    control,
  } = methods;
  const onSubmit = (data) => {
    const unmaskPhone = data?.phone?.replace(/[^\d]/g, '');

    authMutation({
      phone: `994${unmaskPhone}`,
    })
      .unwrap()
      .then(() => {
        navigate(`/otp?phone=${unmaskPhone}`);
      });
  };

  return (
    <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
      <Stack spacing={3} sx={{ my: 2 }}>
        <Controller
          control={control}
          name="phone"
          render={({ field: { value, onChange } }) => (
            <InputMask value={value} onChange={onChange} mask="(99) 999 99 99">
              <FormControl fullWidth>
                <TextField
                  InputProps={{
                    startAdornment: <InputAdornment position="start">994</InputAdornment>,
                  }}
                  placeholder="Phone"
                />
              </FormControl>
            </InputMask>
          )}
        />
      </Stack>
      <LoadingButton fullWidth size="large" type="submit" variant="contained" loading={isSubmitting}>
        Login
      </LoadingButton>
    </FormProvider>
  );
}
